<template>
    <div class="flex items-center justify-center h-screen w-screen relative bg-cover bg-center bg-repeat bg-[url('../assets/background/bg-02.png')]">

        <!-- Modal Login -->
        <div v-if="loginCorrect === true && activeModal === 'login'" class="bg-slate-50 rounded-lg shadow-lg shadow-orange-300 drop-shadow-lg p-4">
            <div class="h-full w-full flex flex-col justify-around items-center xl:gap-y-2 lg:gap-y-2">
                <div class="flex flex-col justify-around xl:gap-y-10 lg:gap-y-10 md:gap-y-4 sm:gap-y-2">
                    <div class="h-full flex flex-col items-center justify-center">
                        <p class="bg-yellow-50 text-2xl font-bold shadow-lg shadow-gray-500 p-5 rounded-lg">ล็อกอินเพื่อเข้าเล่นเกม</p>
                    </div>
                    <div class="h-full flex flex-col items-center justify-center">
                        <label for="user_id" class="text-gray-800 text-xl font-bold leading-tight tracking-normal mb-2">รหัสผู้ใช้</label>
                        <input id="user_id" type="text" maxlength="4" minlength="4" autocomplete="on" class="text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-700 dark:focus:border-indigo-700 bg-white font-normal w-64 h-10 flex items-center pl-3 text-sm border-gray-300 rounded border shadow" onfocus="this.value=''" placeholder="รหัสผู้ใช้"/>
                    </div>
                    <div class="h-full">
                        <p class="cursor-pointer flex flex-col items-center justify-center w-max p-4 bg-sky-500 text-white font-bold text-[30px] rounded-lg shadow-lg hover:ring-4 hover:ring-bg-sky-100" @click="checkCorrect()">เข้าเล่นเกมกันเถอะ</p>
                    </div>
                    <p class="text-xl underline text-center cursor-pointer text-orange-400" @click="showRegister">ลงทะเบียน</p>
                </div>
            </div>
        </div> 

        <!-- Modal Login Fail -->
        <div v-if="loginCorrect === false && activeModal === 'loginFail'">
            <div class="bg-slate-50 rounded-lg shadow-lg shadow-orange-300 drop-shadow-lg p-10">
                <div class="flex flex-col justify-around items-center gap-y-5">
                    <img src="../assets/materials/wrong.png" alt="login fail" class="w-40">
                    <p class="bg-rose-600 text-white text-2xl font-bold shadow-lg shadow-gray-500 p-5 rounded-lg">ไม่ถูกต้องไม่สามารถเข้าเกมได้</p>
                    <p class="cursor-pointer w-max p-4 px-9 bg-sky-500 text-white font-bold text-[30px] rounded-lg shadow-lg hover:ring-4 hover:ring-bg-sky-100" @click="tryAgain()">ลองอีกครั้ง</p>
                </div>
            </div> 
        </div>

        <!-- Modal Register User -->
        <div v-if="loginCorrect === false && activeModal === 'register'" class="bg-slate-50 rounded-lg shadow-lg shadow-orange-300 drop-shadow-lg xl:p-4 lg:p-2 md:p-2 sm:p-2">
            <div class="h-full w-full flex flex-col justify-around items-center xl:gap-y-2 lg:gap-y-2">
                <div class="flex flex-col justify-around items-center xl:gap-y-5 lg:gap-y-5 md:gap-y-2 sm:gap-y-2">
                    <div class="h-full flex flex-col items-center justify-center">
                        <p class="bg-yellow-50 text-2xl font-bold shadow-lg shadow-gray-500 p-5 rounded-lg">ลงทะเบียนสำหรับผู้เล่นใหม่</p>
                    </div>
                    <div class="h-full flex flex-col items-center justify-center">
                        <label for="first_name" class="text-gray-800 text-xl font-bold leading-tight tracking-normal mb-2">ชื่อ <span class="text-rose-700">*</span></label>                        
                        <input id="first_name" onfocus="this.value=''"  type="text" class="text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-700 dark:focus:border-indigo-700 bg-white font-normal w-64 h-10 flex items-center pl-3 text-sm border-gray-300 rounded border shadow" placeholder="ชื่อ"/>                            
                    </div>
                    <div class="h-full flex flex-col items-center justify-center">
                        <label for="last_name" class="text-gray-800 text-xl font-bold leading-tight tracking-normal mb-2">นามสกุล <span class="text-rose-700">*</span></label>
                        <input id="last_name" onfocus="this.value=''" type="text" class="text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-700 dark:focus:border-indigo-700 bg-white font-normal w-64 h-10 flex items-center pl-3 text-sm border-gray-300 rounded border shadow" placeholder="นามสกุล"/>
                    </div>
                    <div class="h-full flex flex-col items-center justify-center">
                        <label for="age" class="text-gray-800 text-xl font-bold leading-tight tracking-normal mb-2">อายุ <span class="text-rose-700">*</span></label>
                        <input id="age" type="number" onfocus="this.value=''"  min="0" class="text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-700 dark:focus:border-indigo-700 bg-white font-normal w-64 h-10 flex items-center pl-3 text-sm border-gray-300 rounded border shadow" placeholder="อายุ"/>
                    </div>
                    <div class="h-full">
                        <p class="cursor-pointer flex flex-col items-center justify-center w-max p-4 bg-sky-500 text-white font-bold text-[30px] rounded-lg shadow-lg hover:ring-4 hover:ring-bg-sky-100" @click="register()">ลงทะเบียน</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firestore from '../js/firebase';
import createAccount from '../js/create-account';
import { collection, getDocs } from "firebase/firestore";

export default {
    name: "Login",
    props: {
        resetGame: Function
    },
    data() {
        return {
            loginCorrect: true,
            activeModal: 'login'
        }
    },
    created() {
        this.checkValidUser();        
    },
    methods: {
        tryAgain () {
            this.loginCorrect = true;
            this.activeModal = "login"
        },
        async checkCorrect (){
            const user_id = document.getElementById("user_id").value;            
            const checked = await this.checkValidUser(user_id);

            if(!user_id){
                alert('Please input a user');                
            }else{
                console.log(checked);
                if(checked){
                    this.$store.dispatch('setIsLogin', true);
                    window.location.href = '/#/dementia/';
                }else{
                    this.loginCorrect = false;
                    this.activeModal = 'loginFail';
                }
                
            }
        },
        async checkValidUser (user_id) {            
            const querySnapshot = await getDocs(collection(firestore, "users"));
            let users = [];            

            querySnapshot.forEach((doc) => {                                                            
                users.push({
                    document_id: doc.id,
                    user_id: doc.data().id,
                    user: doc.data()
                });
            });

            const filterUser = users.filter(item => String(item.user_id) == String(user_id));
            if(filterUser.length > 0){
                // console.log('Validate User is Passed');
                this.$store.dispatch('setUserId', filterUser[0].document_id);
                this.$store.dispatch('setUser', filterUser[0].user);
                this.$store.dispatch('setIsLogin', true);
                return true;
            }else{
                // console.log('Validate User is Failed');
                return false;
            }            
        },      
        showRegister () {
            this.loginCorrect = false;
            this.activeModal = "register"
        },
        async register () {
            const first_name = document.getElementById('first_name').value;
            const last_name = document.getElementById('last_name').value;
            const age = document.getElementById('age').value;

            console.log({
                first_name,
                last_name,
                age
            });

            if(first_name === '' || last_name === '' || age === ''){
                alert('กรุณากรอกข้อมูลให้ครบถ้วน');
            }else{
                const newUser = await createAccount({ firstname: first_name, lastname: last_name, age: age });
                console.log(newUser);
                if(newUser){
                    alert(`บันทึกสำเร็จ \n รหัสเข้าใช้งานคือ ${newUser.user_id} \n กรุณาบันทึกหน้า`);
                    this.$store.dispatch('setUserId', newUser.user_id);
                    this.$store.dispatch('setIsLogin', true);
                    window.location.href = '/#/home/';
                }         
            }            
        }
    }
};
</script>